import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  key: 0,
  class: "title mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "title mb-0"
}
const _hoisted_6 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_7 = { "aria-label": "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb mb-0" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_12 = {
  key: 1,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_13 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "text-md-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "card"
}
const _hoisted_19 = { class: "table-responsive my-3 font-12" }
const _hoisted_20 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_21 = { class: "table-primary nowrap-text" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { class: "form-check pl-0" }
const _hoisted_25 = {
  class: "form-check-label ml-3",
  for: "defaultCheck1"
}
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { class: "form-check pl-0" }
const _hoisted_28 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_29 = { scope: "col" }
const _hoisted_30 = { class: "form-check pl-0" }
const _hoisted_31 = {
  class: "form-check-label ml-3",
  for: "defaultCheck3"
}
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { class: "form-check pl-0" }
const _hoisted_34 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { class: "form-check pl-0" }
const _hoisted_37 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { class: "form-check pl-0" }
const _hoisted_40 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_41 = { scope: "col" }
const _hoisted_42 = { class: "form-check pl-0" }
const _hoisted_43 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_44 = { scope: "col" }
const _hoisted_45 = { class: "form-check pl-0" }
const _hoisted_46 = {
  class: "form-check-label ml-3",
  for: "defaultCheck5"
}
const _hoisted_47 = { scope: "col" }
const _hoisted_48 = { class: "dropdown-menu table-dropdown items-dropdown-menu" }
const _hoisted_49 = { class: "form-group control-with-icon" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search" })
], -1)
const _hoisted_51 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_53 = {
  key: 1,
  ref: "table"
}
const _hoisted_54 = { class: "text-right p-3" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_56 = { class: "dropdown-wrap unit-dropdown position-relative" }
const _hoisted_57 = { class: "mr-3" }
const _hoisted_58 = { class: "dropdown-menu custom-scroll table-dropdown" }
const _hoisted_59 = { class: "dropdown-actions" }
const _hoisted_60 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_62 = { class: "d-flex" }
const _hoisted_63 = { class: "control-wrap" }
const _hoisted_64 = { class: "dropdown-wrap position-relative" }
const _hoisted_65 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_66 = { class: "mr-3" }
const _hoisted_67 = { class: "dropdown-menu" }
const _hoisted_68 = { class: "text-nowrap" }
const _hoisted_69 = { class: "item-desc" }
const _hoisted_70 = { class: "text-nowrap" }
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_74 = { class: "shadow-none" }
const _hoisted_75 = {
  colspan: 8,
  class: "text-right"
}
const _hoisted_76 = { colspan: 3 }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_78 = {
  key: 1,
  class: "my-3"
}
const _hoisted_79 = { key: 2 }
const _hoisted_80 = {
  key: 3,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_81 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_82 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_83 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_84 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_85 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_86 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_87 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_88 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_89 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_90 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_91 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_92 = { class: "inline-items mt-3" }
const _hoisted_93 = {
  key: 0,
  class: "form-group"
}
const _hoisted_94 = { class: "signature-wrap" }
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = { class: "inline-items" }
const _hoisted_97 = { class: "upload-btn-wrapper" }
const _hoisted_98 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "upload-btn-wrapper" }
const _hoisted_103 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_104 = { class: "form-wrap mt-2" }
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { for: "" }
const _hoisted_107 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_108 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_109 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_110 = { class: "row mx-n2" }
const _hoisted_111 = { class: "col-xl-6 px-2" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = { for: "" }
const _hoisted_114 = { class: "text-red" }
const _hoisted_115 = { class: "col-xl-6 px-2" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = { for: "" }
const _hoisted_118 = { class: "col-xl-6 px-2" }
const _hoisted_119 = { class: "form-group" }
const _hoisted_120 = { for: "" }
const _hoisted_121 = { class: "col-xl-6 px-2" }
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = { for: "" }
const _hoisted_124 = { class: "input-group" }
const _hoisted_125 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_126 = { class: "text-red" }
const _hoisted_127 = { class: "col-xl-6 px-2" }
const _hoisted_128 = { class: "form-group" }
const _hoisted_129 = { for: "" }
const _hoisted_130 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_131 = { class: "form-check form-check-inline" }
const _hoisted_132 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_133 = { class: "form-check form-check-inline" }
const _hoisted_134 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_135 = { class: "text-red" }
const _hoisted_136 = { class: "col-xl-6 px-2" }
const _hoisted_137 = { class: "form-group" }
const _hoisted_138 = { for: "projectAddress" }
const _hoisted_139 = { class: "text-end" }
const _hoisted_140 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_141 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_142 = { class: "text-end" }
const _hoisted_143 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_144 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_145 = { class: "row mx-n2" }
const _hoisted_146 = { class: "col-xl-6 px-2" }
const _hoisted_147 = { class: "mb-3" }
const _hoisted_148 = { class: "col-xl-6 px-2" }
const _hoisted_149 = { class: "mb-3" }
const _hoisted_150 = { class: "col-xl-6 px-2" }
const _hoisted_151 = { class: "mb-3" }
const _hoisted_152 = { class: "col-xl-6 px-2" }
const _hoisted_153 = { class: "mb-3" }
const _hoisted_154 = { class: "col-xl-6 px-2" }
const _hoisted_155 = { class: "mb-3" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_158 = { key: 1 }
const _hoisted_159 = { class: "col-xl-6 px-2" }
const _hoisted_160 = { class: "mb-3" }
const _hoisted_161 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_162 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_163 = { class: "form-wrap mt-2" }
const _hoisted_164 = { class: "form-group" }
const _hoisted_165 = { for: "" }
const _hoisted_166 = { class: "col-md-6" }
const _hoisted_167 = { class: "form-check pl-0" }
const _hoisted_168 = {
  class: "form-check-label ml-3",
  for: "defaultCheck6"
}
const _hoisted_169 = { class: "form-group text-right" }
const _hoisted_170 = {
  href: "#",
  class: "btn default-btn btn-outline",
  "data-toggle": "modal",
  "data-target": "#previewModal"
}
const _hoisted_171 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_172 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_173 = {
  class: "modal fade",
  id: "previewModal",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_174 = { class: "modal-dialog" }
const _hoisted_175 = { class: "modal-content" }
const _hoisted_176 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close ml-auto",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_177 = { class: "modal-body bg-light" }
const _hoisted_178 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_179 = { class: "d-flex" }
const _hoisted_180 = { class: "flex-grow-1" }
const _hoisted_181 = { class: "invoice-logo" }
const _hoisted_182 = { class: "invoice-address" }
const _hoisted_183 = { class: "uppercase-text" }
const _hoisted_184 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_185 = { class: "row" }
const _hoisted_186 = { class: "col-md-3" }
const _hoisted_187 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_188 = { class: "col-md-3" }
const _hoisted_189 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_190 = { class: "col-md-3" }
const _hoisted_191 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_192 = { class: "mt-3" }
const _hoisted_193 = { key: 0 }
const _hoisted_194 = { class: "row" }
const _hoisted_195 = { class: "mt-3 border p-2" }
const _hoisted_196 = { key: 0 }
const _hoisted_197 = { key: 1 }
const _hoisted_198 = { key: 2 }
const _hoisted_199 = { class: "table-responsive mt-4 font-12" }
const _hoisted_200 = { class: "table mb-0 table-borderless" }
const _hoisted_201 = { class: "nowrap-text" }
const _hoisted_202 = { class: "table-active" }
const _hoisted_203 = { scope: "col" }
const _hoisted_204 = {
  key: 0,
  scope: "col"
}
const _hoisted_205 = {
  key: 1,
  scope: "col"
}
const _hoisted_206 = {
  key: 2,
  scope: "col"
}
const _hoisted_207 = {
  key: 3,
  scope: "col"
}
const _hoisted_208 = {
  key: 4,
  scope: "col"
}
const _hoisted_209 = {
  key: 5,
  scope: "col"
}
const _hoisted_210 = {
  key: 6,
  scope: "col"
}
const _hoisted_211 = {
  key: 7,
  scope: "col",
  class: "text-end"
}
const _hoisted_212 = { key: 0 }
const _hoisted_213 = { key: 1 }
const _hoisted_214 = { key: 0 }
const _hoisted_215 = { class: "desc-wrap" }
const _hoisted_216 = { key: 1 }
const _hoisted_217 = { key: 2 }
const _hoisted_218 = { key: 3 }
const _hoisted_219 = { key: 4 }
const _hoisted_220 = { key: 5 }
const _hoisted_221 = { key: 0 }
const _hoisted_222 = { key: 1 }
const _hoisted_223 = { key: 6 }
const _hoisted_224 = { key: 7 }
const _hoisted_225 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_226 = { class: "row justify-content-end" }
const _hoisted_227 = { class: "col-lg-4 col-md-6" }
const _hoisted_228 = { class: "total-box mb-4" }
const _hoisted_229 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_230 = { class: "border-top border-top-dashed fs-15" }
const _hoisted_231 = { scope: "row" }
const _hoisted_232 = { class: "text-end" }
const _hoisted_233 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_234 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_235 = {
  key: 1,
  class: "tab-wrap bg-white rounded px-3 pb-3 border mt-3"
}
const _hoisted_236 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_237 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_238 = {
  class: "nav-link active",
  id: "Acknowledgement-tab",
  "data-toggle": "tab",
  "data-target": "#Acknowledgement",
  type: "button",
  role: "tab",
  "aria-controls": "Acknowledgement",
  "aria-selected": "true"
}
const _hoisted_239 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_240 = {
  class: "nav-link",
  id: "LegalStatement-tab",
  "data-toggle": "tab",
  "data-target": "#LegalStatement",
  type: "button",
  role: "tab",
  "aria-controls": "LegalStatement",
  "aria-selected": "false"
}
const _hoisted_241 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_242 = {
  class: "tab-pane fade show active",
  id: "Acknowledgement",
  role: "tabpanel",
  "aria-labelledby": "Acknowledgement-tab"
}
const _hoisted_243 = {
  class: "tab-pane fade",
  id: "LegalStatement",
  role: "tabpanel",
  "aria-labelledby": "LegalStatement-tab"
}
const _hoisted_244 = {
  key: 2,
  class: "alert alert-info mt-3"
}
const _hoisted_245 = { class: "mb-0" }
const _hoisted_246 = {
  key: 3,
  class: "row"
}
const _hoisted_247 = { class: "col-md-4 mt-4" }
const _hoisted_248 = { class: "signature-wrap mt-2" }
const _hoisted_249 = { class: "modal-wrap default-modal" }
const _hoisted_250 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_251 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_252 = { class: "modal-content" }
const _hoisted_253 = { class: "modal-header" }
const _hoisted_254 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_255 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_256 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_257 = { class: "modal-body" }
const _hoisted_258 = { class: "form-group" }
const _hoisted_259 = { for: "" }
const _hoisted_260 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_261 = { class: "form-group" }
const _hoisted_262 = { for: "" }
const _hoisted_263 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_264 = { class: "modal-footer" }
const _hoisted_265 = { class: "modal-wrap default-modal" }
const _hoisted_266 = {
  class: "modal fade",
  id: "deleteItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_267 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_268 = { class: "modal-content" }
const _hoisted_269 = { class: "modal-header" }
const _hoisted_270 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_271 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_272 = { class: "modal-body" }
const _hoisted_273 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_274 = { class: "text-danger" }
const _hoisted_275 = { class: "modal-footer" }
const _hoisted_276 = { class: "modal-wrap default-modal" }
const _hoisted_277 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "updateUpload",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_278 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_279 = { class: "modal-content" }
const _hoisted_280 = { class: "modal-header" }
const _hoisted_281 = { class: "d-block" }
const _hoisted_282 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_283 = { class: "text-muted" }
const _hoisted_284 = { class: "modal-body" }
const _hoisted_285 = { class: "modal-content" }
const _hoisted_286 = { class: "modal-footer justify-content-start" }
const _hoisted_287 = /*#__PURE__*/_createVNode("i", { class: "fa fa-crop-alt" }, null, -1)
const _hoisted_288 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_289 = /*#__PURE__*/_createVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_290 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_291 = { class: "modal-wrap default-modal" }
const _hoisted_292 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_293 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_294 = { class: "modal-content" }
const _hoisted_295 = { class: "modal-header" }
const _hoisted_296 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_297 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_298 = { class: "modal-body" }
const _hoisted_299 = { class: "row" }
const _hoisted_300 = { class: "col-md-12" }
const _hoisted_301 = {
  key: 0,
  class: "form-group"
}
const _hoisted_302 = { for: "" }
const _hoisted_303 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_304 = { class: "form-group" }
const _hoisted_305 = { for: "" }
const _hoisted_306 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_307 = { class: "form-group" }
const _hoisted_308 = { for: "" }
const _hoisted_309 = { class: "form-group" }
const _hoisted_310 = { for: "" }
const _hoisted_311 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_312 = { class: "custom-file" }
const _hoisted_313 = { class: "upload-btn-wrapper" }
const _hoisted_314 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_315 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_316 = { class: "form-group" }
const _hoisted_317 = { for: "" }
const _hoisted_318 = { class: "form-group" }
const _hoisted_319 = { for: "" }
const _hoisted_320 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_PriceInputField = _resolveComponent("PriceInputField")
  const _component_GoogleAddressCustomer = _resolveComponent("GoogleAddressCustomer")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_CreateLineItemInJobEstimation = _resolveComponent("CreateLineItemInJobEstimation")
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")
  const _component_Editor = _resolveComponent("Editor")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.state.ui.isLoading.isEdit)
              ? (_openBlock(), _createBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t('edit_job_estimation')), 1))
              : (_openBlock(), _createBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('update_job_estimation')), 1)),
            _createVNode("div", _hoisted_6, [
              _createVNode("nav", _hoisted_7, [
                _createVNode("ol", _hoisted_8, [
                  _hoisted_9,
                  (_ctx.state.ui.isLoading.isEdit)
                    ? (_openBlock(), _createBlock("li", _hoisted_10, [
                        _createVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('edit_job_estimation')), 1)
                      ]))
                    : (_openBlock(), _createBlock("li", _hoisted_12, [
                        _createVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('create_job_estimation')), 1)
                      ]))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              (_ctx.state.ui.isLoading.addNewSubItem)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
                  }, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ]))
                : (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoJobEstimation && _ctx.gotoJobEstimation(...args)))
                  }, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.sendJobEstimation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"])
      ]),
      (!_ctx.state.ui.isLoading.addNewSubItem)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("table", _hoisted_20, [
                _createVNode("thead", _hoisted_21, [
                  _createVNode("tr", null, [
                    _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('item')), 1),
                    _createVNode("th", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.fields.description = $event)),
                          id: "defaultCheck1"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.description]
                        ]),
                        _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('description')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.fields.quantity = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.quantity]
                        ]),
                        _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('qty')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.fields.unit = $event)),
                          id: "defaultCheck3"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.unit]
                        ]),
                        _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('unit')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.fields.cost = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.cost]
                        ]),
                        _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('cost')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.fields.subTotal = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.subTotal]
                        ]),
                        _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('sub_total')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.fields.markup = $event)),
                          id: "defaultCheck4"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.markup]
                        ]),
                        _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('markup')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.fields.allowance = $event)),
                          id: "defaultCheck4"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.allowance]
                        ]),
                        _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('allowance')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.fields.total = $event)),
                          id: "defaultCheck5"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.total]
                        ]),
                        _createVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_47, _toDisplayString(_ctx.$t('action')), 1)
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: selectedItemIndex }, [
                      _createVNode("td", null, [
                        _createVNode("div", {
                          class: `dropdown-wrap unit-dropdown position-relative items-dropdown job-item-dropdown${selectedItemIndex}`
                        }, [
                          (selectedItem.parent_id)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                class: "dropdown-toggle d-block border rounded py-2 px-3",
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: ($event: any) => (_ctx.onToggleChooseItem(selectedItemIndex))
                              }, _toDisplayString(selectedItem.name ? selectedItem.mainName + ':' + selectedItem.name : _ctx.$t('choose_item')), 9, ["onClick"]))
                            : (_openBlock(), _createBlock("a", {
                                key: 1,
                                class: "dropdown-toggle d-block border rounded py-2 px-3",
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: ($event: any) => (_ctx.onToggleChooseItem(selectedItemIndex))
                              }, _toDisplayString(selectedItem.name ? selectedItem.name : _ctx.$t('choose_item')), 9, ["onClick"])),
                          _createVNode("div", _hoisted_48, [
                            _createVNode("a", {
                              class: "dropdown-item border-bottom text-success",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.addNewSubItem(selectedItemIndex))
                            }, "+ " + _toDisplayString(_ctx.$t('add')) + " " + _toDisplayString(_ctx.$t('new_item')), 9, ["onClick"]),
                            _createVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.searchName = $event)),
                                class: "form-control w-100",
                                placeholder: _ctx.$t('enter_to_search'),
                                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
                              }, null, 40, ["placeholder"]), [
                                [_vModelText, _ctx.state.data.searchName]
                              ])
                            ]),
                            (_ctx.state.ui.isLoading.getData)
                              ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                  _hoisted_52
                                ]))
                              : _createCommentVNode("", true),
                            (selectedItem.tableSelected)
                              ? (_openBlock(), _createBlock("div", _hoisted_53, null, 512))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_54, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "btn default-btn btn-sm jobitem-btn",
                                onClick: ($event: any) => (_ctx.closeSelected(selectedItemIndex))
                              }, [
                                _hoisted_55,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('close')), 1)
                              ], 8, ["onClick"])
                            ])
                          ])
                        ], 2)
                      ]),
                      _createVNode("td", null, [
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                          rows: 5
                        }, null, 8, ["onUpdate:modelValue"]), [
                          [_vModelText, selectedItem.description]
                        ])
                      ]),
                      _createVNode("td", null, [
                        _withDirectives(_createVNode("input", {
                          type: "number",
                          class: selectedItem.quantityError ? 'form-control error-field' : 'form-control',
                          "onUpdate:modelValue": ($event: any) => (selectedItem.quantity = $event),
                          onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                        }, null, 42, ["onUpdate:modelValue", "onKeyup"]), [
                          [_vModelText, selectedItem.quantity]
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_56, [
                          _createVNode("a", {
                            class: selectedItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createVNode("span", _hoisted_57, _toDisplayString(selectedItem.unit ?
                                                selectedItem.unit.name : 'Select Unit'), 1)
                          ], 2),
                          _createVNode("div", _hoisted_58, [
                            _createVNode("a", {
                              class: "dropdown-item border-bottom text-success",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.addNewUnit(selectedItem))
                            }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                              return (_openBlock(), _createBlock("a", {
                                class: "dropdown-item with-actions",
                                href: "javascript:void(0)",
                                key: unitIndex
                              }, [
                                _createVNode("span", {
                                  class: "unit-title d-block",
                                  onClick: ($event: any) => (_ctx.changeUnit(selectedItemIndex, unit))
                                }, _toDisplayString(unit.name), 9, ["onClick"]),
                                _createVNode("span", _hoisted_59, [
                                  _createVNode("span", {
                                    class: "actions-text",
                                    onClick: ($event: any) => (_ctx.editUnit(unit))
                                  }, [
                                    _hoisted_60,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                  ], 8, ["onClick"]),
                                  _createVNode("span", {
                                    class: "actions-text ml-2",
                                    onClick: ($event: any) => (_ctx.deleteUnit(selectedItem, unit))
                                  }, [
                                    _hoisted_61,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        (selectedItem.cost)
                          ? (_openBlock(), _createBlock(_component_PriceInputField, {
                              key: 0,
                              parentClass: selectedItem.costError ? 'form-control error-field' : 'form-control',
                              price: selectedItem.cost,
                              onUpdateItem: ($event: any) => (_ctx.updateItem(selectedItemIndex, $event)),
                              onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                            }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup"]))
                          : _withDirectives((_openBlock(), _createBlock("input", {
                              key: 1,
                              type: "text",
                              class: selectedItem.costError ? 'form-control error-field' : 'form-control',
                              "onUpdate:modelValue": ($event: any) => (selectedItem.cost = $event),
                              onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                            }, null, 42, ["onUpdate:modelValue", "onKeyup"])), [
                              [_vModelText, selectedItem.cost]
                            ])
                      ]),
                      _createVNode("td", null, _toDisplayString(_ctx.usdPriceFormate(selectedItem.subTotal ? selectedItem.subTotal : 0)), 1),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_62, [
                          _createVNode("div", _hoisted_63, [
                            (selectedItem.markup_type == 0)
                              ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                  key: 0,
                                  parentClass: 'form-control',
                                  price: selectedItem.markup,
                                  onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(selectedItemIndex, $event)),
                                  onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                              : _createCommentVNode("", true),
                            (selectedItem.markup_type == 1)
                              ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                  key: 1,
                                  parentClass: 'form-control',
                                  price: selectedItem.markup,
                                  from: _ctx.state.data.inputFrom,
                                  onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(selectedItemIndex, $event)),
                                  onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_64, [
                            _createVNode("a", _hoisted_65, [
                              _createVNode("span", _hoisted_66, _toDisplayString(selectedItem.markup_type == 0 ?
                                                    '$' : '%'), 1)
                            ]),
                            _createVNode("div", _hoisted_67, [
                              _createVNode("a", {
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 0))
                              }, "$", 8, ["onClick"]),
                              _createVNode("a", {
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 1))
                              }, "%", 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode(_component_PriceInputField, {
                          parentClass: 'form-control',
                          price: selectedItem.allowance,
                          onUpdateItem: ($event: any) => (_ctx.updateItemAllowance(selectedItemIndex, $event))
                        }, null, 8, ["price", "onUpdateItem"])
                      ]),
                      _createVNode("td", _hoisted_68, [
                        _createVNode("div", _hoisted_69, _toDisplayString(_ctx.usdPriceFormate(selectedItem.total ? selectedItem.total : 0)), 1)
                      ]),
                      _createVNode("td", _hoisted_70, [
                        (Object.keys(selectedItem).length === 0 || selectedItemIndex == _ctx.state.selectItems.length - 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0)",
                              class: "btn enable-btn mr-1",
                              onClick: ($event: any) => (_ctx.addMoreSubItems(selectedItem)),
                              title: "add"
                            }, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.selectItems.length != 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 1,
                              href: "javascript:void(0)",
                              class: "btn btn-info mr-1",
                              onClick: ($event: any) => (_ctx.cloneItem(selectedItemIndex, selectedItem)),
                              title: _ctx.$t('copy')
                            }, [
                              _hoisted_72,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('copy')), 1)
                            ], 8, ["onClick", "title"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.selectItems.length != 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 2,
                              href: "javascript:void(0)",
                              class: "btn delete-btn",
                              onClick: ($event: any) => (_ctx.deleteItemShow(selectedItem)),
                              title: "remove"
                            }, [
                              _hoisted_73,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  _createVNode("tr", _hoisted_74, [
                    _createVNode("td", _hoisted_75, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                      ]),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    _createVNode("td", _hoisted_76, [
                      _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.totalMarkUP)), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_77,
      (!_ctx.state.data.details.logo)
        ? (_openBlock(), _createBlock("div", _hoisted_78, [
            _createVNode("a", {
              "data-toggle": "modal",
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
            }, _toDisplayString(_ctx.$t('add_company_information')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.data.details.acknowledgement &&
            _ctx.state.data.details.legal_statement
        )
        ? (_openBlock(), _createBlock("p", _hoisted_79, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.data.details.acknowledgement &&
            _ctx.state.data.details.legal_statement
        )
        ? (_openBlock(), _createBlock("div", _hoisted_80, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
              _createVNode("a", {
                class: "btn default-btn btn-sm ms-2",
                title: "Edit",
                href: "javascript:void(0)",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
              }, [
                _hoisted_81,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
              ])
            ]),
            (_ctx.state.data.details.logo)
              ? (_openBlock(), _createBlock("div", _hoisted_82, [
                  (_ctx.state.data.details.logo && _ctx.state.data.details.logo.file)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "rounded",
                        src: _ctx.state.data.details.logo.file
                    ? _ctx.state.data.details.logo.file
                    : _ctx.state.data.details.logo
                    ,
                        alt: ""
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("img", {
                        key: 1,
                        class: "rounded",
                        src: _ctx.state.data.details.logo,
                        alt: ""
                      }, null, 8, ["src"]))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_83, [
              _createVNode("ul", _hoisted_84, [
                _createVNode("li", _hoisted_85, [
                  _createVNode("button", _hoisted_86, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                ]),
                _createVNode("li", _hoisted_87, [
                  _createVNode("button", _hoisted_88, _toDisplayString(_ctx.$t('legal_statement')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_89, [
                _createVNode("div", _hoisted_90, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.details.acknowledgement
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode("div", _hoisted_91, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.details.legal_statement
                  }, null, 8, ["innerHTML"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_92, [
        _createVNode("ul", null, [
          _createVNode("li", null, [
            (_ctx.state.data.cropSignature || _ctx.state.data.sendarSignature)
              ? (_openBlock(), _createBlock("div", _hoisted_93, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_94, [
                      _createVNode("img", {
                        src: _ctx.state.data.cropSignature ? _ctx.state.data.cropSignature : _ctx.state.data.sendarSignature,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_95, [
              _createVNode("div", _hoisted_96, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("div", _hoisted_97, [
                      _createVNode("button", _hoisted_98, [
                        _hoisted_99,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                      }, null, 32)
                    ])
                  ]),
                  _createVNode("li", null, [
                    _createVNode("button", {
                      class: "btn default-btn",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                    }, [
                      _hoisted_100,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                    ])
                  ]),
                  (_ctx.state.data.haveProfileSign)
                    ? (_openBlock(), _createBlock("li", _hoisted_101, [
                        _createVNode("div", _hoisted_102, [
                          _createVNode("button", {
                            for: "formFileSm",
                            class: "btn default-btn mr-2",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.userSignature('use')))
                          }, [
                            _hoisted_103,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("li", null, [
                    _createVNode("button", {
                      class: "btn red-btn",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearSignature()))
                    }, _toDisplayString(_ctx.$t('clear')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_104, [
        _createVNode("div", _hoisted_105, [
          _createVNode("label", _hoisted_106, _toDisplayString(_ctx.$t('note')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.note = $event))
          }, null, 512), [
            [_vModelText, _ctx.state.data.note]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_107, [
        (_ctx.state.data.selectedCustomers.length)
          ? (_openBlock(), _createBlock("div", _hoisted_108, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "col-md-4 col-sm-6 mb-2 px-2",
                  key: customerIndex
                }, [
                  (customer.isEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_109, [
                        _createVNode("div", _hoisted_110, [
                          _createVNode("div", _hoisted_111, [
                            _createVNode("div", _hoisted_112, [
                              _createVNode("label", _hoisted_113, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                disabled: "",
                                class: customer.emailError
                                        ? 'form-control error-field'
                                        : 'form-control'
                                        ,
                                "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                              }, null, 10, ["onUpdate:modelValue"]), [
                                [_vModelText, customer.email]
                              ]),
                              _createVNode("p", _hoisted_114, _toDisplayString(customer.emailError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_115, [
                            _createVNode("div", _hoisted_116, [
                              _createVNode("label", _hoisted_117, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, customer.first_name]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_118, [
                            _createVNode("div", _hoisted_119, [
                              _createVNode("label", _hoisted_120, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, customer.last_name]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_121, [
                            _createVNode("div", _hoisted_122, [
                              _createVNode("label", _hoisted_123, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                              ]),
                              _createVNode("div", _hoisted_124, [
                                _hoisted_125,
                                _withDirectives(_createVNode("input", {
                                  type: "number",
                                  class: customer.phoneError ? 'form-control error-field' : 'form-control',
                                  placeholder: _ctx.$t('mobile_number_only'),
                                  "onUpdate:modelValue": ($event: any) => (customer.phone = $event)
                                }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                  [_vModelText, customer.phone]
                                ]),
                                _createVNode("p", _hoisted_126, _toDisplayString(customer.phoneError), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_127, [
                            _createVNode("div", _hoisted_128, [
                              _createVNode("label", _hoisted_129, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                              ]),
                              _createVNode("div", _hoisted_130, [
                                _createVNode("div", _hoisted_131, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "inlineCheckbox1",
                                    value: "true",
                                    "onUpdate:modelValue": ($event: any) => (customer.mailNotification = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelCheckbox, customer.mailNotification]
                                  ]),
                                  _createVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('email')), 1)
                                ]),
                                _createVNode("div", _hoisted_133, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "inlineCheckbox2",
                                    value: "true",
                                    "onUpdate:modelValue": ($event: any) => (customer.smsNotification = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelCheckbox, customer.smsNotification]
                                  ]),
                                  _createVNode("label", _hoisted_134, _toDisplayString(_ctx.$t('sms')), 1)
                                ])
                              ])
                            ]),
                            _createVNode("p", _hoisted_135, _toDisplayString(customer.mailNotificationError), 1)
                          ]),
                          _createVNode("div", _hoisted_136, [
                            _createVNode("div", _hoisted_137, [
                              _createVNode("label", _hoisted_138, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('address')), 1)
                              ]),
                              _createVNode(_component_GoogleAddressCustomer, {
                                latitude: _ctx.latitude,
                                longitude: _ctx.longitude,
                                address: customer.address_line1,
                                visible: _ctx.showMap,
                                isEdit: true,
                                "onUpdate:latitude": _ctx.updateLatitude,
                                "onUpdate:longitude": _ctx.updateLongitude,
                                "onUpdate:address": _ctx.updateAddress
                              }, null, 8, ["latitude", "longitude", "address", "visible", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_139, [
                          _createVNode("a", {
                            class: "btn default-btn btn-sm",
                            title: "Update",
                            href: "javascript:void(\n                            0)",
                            onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                          }, [
                            _hoisted_140,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                          ], 8, ["onClick"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_141, [
                        _createVNode("div", _hoisted_142, [
                          _createVNode("a", {
                            class: "btn default-btn btn-sm mr-2",
                            title: "Edit",
                            href: "javascript:void(\n                            0)",
                            onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                          }, [
                            _hoisted_143,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                          ], 8, ["onClick"]),
                          _createVNode("a", {
                            class: "btn btn-sm red-btn",
                            title: "Delete",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.showDelete(customer))
                          }, [
                            _hoisted_144,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                          ], 8, ["onClick"])
                        ]),
                        _createVNode("div", _hoisted_145, [
                          _createVNode("div", _hoisted_146, [
                            _createVNode("div", _hoisted_147, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(customer.email), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_148, [
                            _createVNode("div", _hoisted_149, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_150, [
                            _createVNode("div", _hoisted_151, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_152, [
                            _createVNode("div", _hoisted_153, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(customer.phone), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_154, [
                            _createVNode("div", _hoisted_155, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                (customer.mailNotification)
                                  ? (_openBlock(), _createBlock("small", _hoisted_156, _toDisplayString(_ctx.$t('mail')), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_157,
                                (customer.smsNotification)
                                  ? (_openBlock(), _createBlock("small", _hoisted_158, _toDisplayString(_ctx.$t('sms')), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_159, [
                            _createVNode("div", _hoisted_160, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                                ])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_161, [
              _hoisted_162,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_not_selected')) + " " + _toDisplayString(_ctx.$t('please_select_or_add_customer_email')), 1)
            ]))
      ]),
      _createVNode("div", _hoisted_163, [
        _createVNode("div", _hoisted_164, [
          _createVNode("label", _hoisted_165, _toDisplayString(_ctx.$t('customer_emails')), 1),
          _createVNode(_component_multiselect, {
            modelValue: _ctx.state.data.selectedCustomers,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.selectedCustomers = $event)),
            "tag-placeholder": "Select or add customer email",
            placeholder: _ctx.$t('select_or_add_customer_email'),
            label: "code",
            "track-by": "code",
            options: _ctx.state.data.allCustomer,
            multiple: true,
            taggable: true,
            onTag: _ctx.addCustomerEmail,
            onSelect: _ctx.changeValue
          }, null, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
          _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_not_owner_email_only')), 513), [
            [_vShow, _ctx.isInvalid]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_166, [
        _createVNode("div", _hoisted_167, [
          _withDirectives(_createVNode("input", {
            class: "form-check-input mt-0 ml-0",
            type: "checkbox",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.approveByAll = $event)),
            id: "defaultCheck6"
          }, null, 512), [
            [_vModelCheckbox, _ctx.state.approveByAll]
          ]),
          _createVNode("label", _hoisted_168, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_169, [
        _createVNode("button", {
          type: "submit",
          class: "btn default-btn mr-2",
          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.sendJobEstimation && _ctx.sendJobEstimation(...args))),
          disabled: _ctx.state.ui.isPostLoading.createJobEstimation
        }, _toDisplayString(_ctx.state.ui.isPostLoading.createJobEstimation ?
                    _ctx.$t('loading1') : _ctx.$t('update')), 9, ["disabled"]),
        _createVNode("a", _hoisted_170, [
          _hoisted_171,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('preview')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_172, [
        _createVNode("div", _hoisted_173, [
          _createVNode("div", _hoisted_174, [
            _createVNode("div", _hoisted_175, [
              _hoisted_176,
              _createVNode("div", _hoisted_177, [
                _createVNode("div", _hoisted_178, [
                  _createVNode("div", _hoisted_179, [
                    _createVNode("div", _hoisted_180, [
                      _createVNode("div", _hoisted_181, [
                        _createVNode("img", {
                          src: _ctx.state.data.companyInfo.logo.file
                                                ? _ctx.state.data.companyInfo.logo.file
                                                : _ctx.state.data.companyInfo.logo
                                                ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_182, [
                        _createVNode("p", null, [
                          _createVNode("strong", _hoisted_183, _toDisplayString(_ctx.$t('address')), 1)
                        ]),
                        _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                      ])
                    ])
                  ]),
                  _hoisted_184,
                  _createVNode("div", _hoisted_185, [
                    _createVNode("div", _hoisted_186, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_187, _toDisplayString(_ctx.$t('estimation_title')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                    ]),
                    _createVNode("div", _hoisted_188, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_189, _toDisplayString(_ctx.$t('estimation_no')), 1)
                      ]),
                      _createVNode("p", null, "# " + _toDisplayString(_ctx.state.data.details.no), 1)
                    ]),
                    _createVNode("div", _hoisted_190, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_191, _toDisplayString(_ctx.$t('date')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.createDate), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_192, [
                    (_ctx.state.data && _ctx.state.data.selectedCustomers && _ctx.state.data.selectedCustomers.length)
                      ? (_openBlock(), _createBlock("p", _hoisted_193, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_194, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "col-md-4",
                          key: customerIndex
                        }, [
                          _createVNode("div", _hoisted_195, [
                            (customer.first_name || customer.last_name)
                              ? (_openBlock(), _createBlock("p", _hoisted_196, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                  _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.email)
                              ? (_openBlock(), _createBlock("p", _hoisted_197, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.email), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.phone)
                              ? (_openBlock(), _createBlock("p", _hoisted_198, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.phone), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_199, [
                    _createVNode("table", _hoisted_200, [
                      _createVNode("thead", _hoisted_201, [
                        _createVNode("tr", _hoisted_202, [
                          _createVNode("th", _hoisted_203, _toDisplayString(_ctx.$t('item')), 1),
                          (_ctx.state.fields.description)
                            ? (_openBlock(), _createBlock("th", _hoisted_204, _toDisplayString(_ctx.$t('description')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.quantity)
                            ? (_openBlock(), _createBlock("th", _hoisted_205, _toDisplayString(_ctx.$t('qty')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.unit)
                            ? (_openBlock(), _createBlock("th", _hoisted_206, _toDisplayString(_ctx.$t('unit')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.cost)
                            ? (_openBlock(), _createBlock("th", _hoisted_207, _toDisplayString(_ctx.$t('cost')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.subTotal)
                            ? (_openBlock(), _createBlock("th", _hoisted_208, _toDisplayString(_ctx.$t('sub_total')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.markup)
                            ? (_openBlock(), _createBlock("th", _hoisted_209, _toDisplayString(_ctx.$t('markup')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.allowance)
                            ? (_openBlock(), _createBlock("th", _hoisted_210, _toDisplayString(_ctx.$t('allowance')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.total)
                            ? (_openBlock(), _createBlock("th", _hoisted_211, _toDisplayString(_ctx.$t('total')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              (item.parent_id)
                                ? (_openBlock(), _createBlock("p", _hoisted_212, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                                : (_openBlock(), _createBlock("p", _hoisted_213, _toDisplayString(item.name), 1))
                            ]),
                            (_ctx.state.fields.description)
                              ? (_openBlock(), _createBlock("td", _hoisted_214, [
                                  _createVNode("div", _hoisted_215, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity)
                              ? (_openBlock(), _createBlock("td", _hoisted_216, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit)
                              ? (_openBlock(), _createBlock("td", _hoisted_217, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost)
                              ? (_openBlock(), _createBlock("td", _hoisted_218, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal)
                              ? (_openBlock(), _createBlock("td", _hoisted_219, [
                                  _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup)
                              ? (_openBlock(), _createBlock("td", _hoisted_220, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_221, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_222, _toDisplayString(item.markup), 1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance)
                              ? (_openBlock(), _createBlock("td", _hoisted_223, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total)
                              ? (_openBlock(), _createBlock("td", _hoisted_224, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_225,
                  _createVNode("div", _hoisted_226, [
                    _createVNode("div", _hoisted_227, [
                      _createVNode("div", _hoisted_228, [
                        _createVNode("table", _hoisted_229, [
                          _createVNode("tbody", null, [
                            _createVNode("tr", _hoisted_230, [
                              _createVNode("th", _hoisted_231, _toDisplayString(_ctx.$t('total_amount')), 1),
                              _createVNode("th", _hoisted_232, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_233,
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement)
                    ? (_openBlock(), _createBlock("p", _hoisted_234, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement)
                    ? (_openBlock(), _createBlock("div", _hoisted_235, [
                        _createVNode("ul", _hoisted_236, [
                          _createVNode("li", _hoisted_237, [
                            _createVNode("button", _hoisted_238, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                          ]),
                          _createVNode("li", _hoisted_239, [
                            _createVNode("button", _hoisted_240, _toDisplayString(_ctx.$t('legal_statement1')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_241, [
                          _createVNode("div", _hoisted_242, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createVNode("div", _hoisted_243, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.note)
                    ? (_openBlock(), _createBlock("div", _hoisted_244, [
                        _createVNode("p", _hoisted_245, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.cropSignature || _ctx.state.data.sendarSignature)
                    ? (_openBlock(), _createBlock("div", _hoisted_246, [
                        _createVNode("div", _hoisted_247, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('signature')) + ":", 1)
                          ]),
                          _createVNode("div", _hoisted_248, [
                            _createVNode("img", {
                              src: _ctx.state.data.cropSignature?_ctx.state.data.cropSignature : _ctx.state.data.sendarSignature,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 4,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_249, [
        _createVNode("div", _hoisted_250, [
          _createVNode("div", _hoisted_251, [
            _createVNode("div", _hoisted_252, [
              _createVNode("div", _hoisted_253, [
                (_ctx.state.ui.isLoading.isUnitEdit)
                  ? (_openBlock(), _createBlock("h5", _hoisted_254, _toDisplayString(_ctx.$t('update_unit')), 1))
                  : (_openBlock(), _createBlock("h5", _hoisted_255, _toDisplayString(_ctx.$t('add_unit')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_256
                ])
              ]),
              _createVNode("div", _hoisted_257, [
                _createVNode("div", _hoisted_258, [
                  _createVNode("label", _hoisted_259, _toDisplayString(_ctx.$t('name')), 1),
                  _withDirectives(_createVNode("input", {
                    class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.data.unit.name = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.state.data.unit.name]
                  ]),
                  (_ctx.state.ui.errors.validationErrorList.unitName)
                    ? (_openBlock(), _createBlock("p", _hoisted_260, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_261, [
                  _createVNode("label", _hoisted_262, _toDisplayString(_ctx.$t('abbreviation')), 1),
                  _withDirectives(_createVNode("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.unit.abbreviation]
                  ]),
                  (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                    ? (_openBlock(), _createBlock("p", _hoisted_263, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_264, [
                (_ctx.state.ui.isLoading.isUnitEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.ui.isLoading.addNewSubItem)
        ? (_openBlock(), _createBlock(_component_CreateLineItemInJobEstimation, {
            key: 5,
            onSave: _ctx.saveItem
          }, null, 8, ["onSave"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_265, [
        _createVNode("div", _hoisted_266, [
          _createVNode("div", _hoisted_267, [
            _createVNode("div", _hoisted_268, [
              _createVNode("div", _hoisted_269, [
                _createVNode("h5", _hoisted_270, _toDisplayString(_ctx.$t('delete_subitem')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.deleteItemClose()))
                }, [
                  _hoisted_271
                ])
              ]),
              _createVNode("div", _hoisted_272, [
                _hoisted_273,
                _createVNode("span", _hoisted_274, _toDisplayString(_ctx.$t('are_you_sure')), 1)
              ]),
              _createVNode("div", _hoisted_275, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.deleteItemClose()))
                }, _toDisplayString(_ctx.$t('no')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-dismiss": "modal",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.removeSelectedSubItem(_ctx.state.selectDeleteItem)))
                }, _toDisplayString(_ctx.$t('yes')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_276, [
        _createVNode("div", _hoisted_277, [
          _createVNode("div", _hoisted_278, [
            _createVNode("div", _hoisted_279, [
              _createVNode("div", _hoisted_280, [
                _createVNode("div", _hoisted_281, [
                  _createVNode("h5", _hoisted_282, _toDisplayString(_ctx.$t('upload_signature')), 1),
                  _createVNode("p", _hoisted_283, _toDisplayString(_ctx.$t('please_upload_valid_signature')) + ".", 1)
                ])
              ]),
              _createVNode("div", _hoisted_284, [
                _createVNode("div", _hoisted_285, [
                  _createVNode(_component_VuePictureCropper, {
                    boxStyle: {
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: '#f8f8f8',
                                    margin: 'auto',
                                },
                    img: _ctx.state.data.newUploadImge,
                    options: {
                                    viewMode: 1,
                                    dragMode: 'crop',
                                    aspectRatio: 30 / 20,
                                }
                  }, null, 8, ["img"])
                ])
              ]),
              _createVNode("div", _hoisted_286, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args)))
                }, [
                  _hoisted_287,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('crop')), 1)
                ]),
                _createVNode("button", {
                  class: "btn default-btn",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.clearCrop && _ctx.clearCrop(...args)))
                }, [
                  _hoisted_288,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('clear')), 1)
                ]),
                _createVNode("button", {
                  class: "btn default-btn",
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.resetCrop && _ctx.resetCrop(...args)))
                }, [
                  _hoisted_289,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('reset')), 1)
                ]),
                _createVNode("button", {
                  class: "btn red-btn",
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.hideShowUploadImageModel && _ctx.hideShowUploadImageModel(...args)))
                }, [
                  _hoisted_290,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cancel')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_291, [
        _createVNode("div", _hoisted_292, [
          _createVNode("div", _hoisted_293, [
            _createVNode("div", _hoisted_294, [
              _createVNode("div", _hoisted_295, [
                _createVNode("h5", _hoisted_296, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_297
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_298, [
                _createVNode("div", _hoisted_299, [
                  _createVNode("div", _hoisted_300, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_301, [
                          _createVNode("label", _hoisted_302, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_303, [
                        _createVNode("div", _hoisted_304, [
                          _createVNode("label", _hoisted_305, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_phone_number]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_306, [
                        _createVNode("div", _hoisted_307, [
                          _createVNode("label", _hoisted_308, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_309, [
                  _createVNode("label", _hoisted_310, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.details.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_311, [
                        _createVNode("img", {
                          src: _ctx.state.data.details.logo.file
                                        ? _ctx.state.data.details.logo.file
                                        : _ctx.state.data.details.logo
                                        ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_312, [
                    _createVNode("div", _hoisted_313, [
                      _createVNode("button", _hoisted_314, [
                        _hoisted_315,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_316, [
                  _createVNode("label", _hoisted_317, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.details.acknowledgement,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.state.data.details.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_318, [
                  _createVNode("label", _hoisted_319, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.details.legal_statement,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.state.data.details.legal_statement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_320, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}